

export class LoadingSpinner {

    static go ( className:string = 'blue' ) {
        // console.log('@@ go', className);
        setTimeout ( () =>{ let e = document.getElementById('loading-spinner'); if ( e ) { e.classList.add(className); } }, 150 );
    }

    static error() {
        let me = this;
        // console.log('@@ error');
        this.go('error');
        setTimeout ( () =>{ me.end(); }, 2000 );
    }

    static end() {
        let me = this;
        // console.log('@@ end');
        this.go('done');
        setTimeout ( () =>{ me.remove(); }, 2000 );
    }

    static remove() {
        // console.log('@@ remove');
        setTimeout ( () =>{ let e = document.getElementById('loading-spinner'); if ( e ) { e.remove(); } }, 150 );
    }
}